// React Query keys for Hours & pausing (under ['shop', id] so shop-wide invalidation reaches them).
export const hoursKeys = {
  hours: (shopId: string) => ['shop', shopId, 'hours'] as const,
};
